import { closeSnackbar, SnackbarContent, CustomContentProps } from 'notistack';
import { forwardRef } from 'react';

import {
  IconX,
  IconExclamationCircle,
  IconSquareRoundedCheck,
} from '@tabler/icons-react';

import Button from '../Button/Button';

interface ICustomSnackbarProps extends CustomContentProps {
  message: string;
}
const CustomSnackbar = forwardRef<HTMLDivElement, ICustomSnackbarProps>(
  ({ id, message, variant }, ref) => {
    const isSuccess = variant === 'success';
    const isError = variant === 'error';

    let backgroundClass = 'bg-gray-600';
    if (isSuccess) {
      backgroundClass = 'bg-success-light-50';
    } else if (isError) {
      backgroundClass = 'bg-error-light-50';
    }

    return (
      <SnackbarContent ref={ref} role="alert">
        <div
          className={`flex items-center gap-3 p-4 rounded-xl shadow-lg min-w-75 max-w-150 ${backgroundClass}`}
        >
          {/* Icon */}
          <div className="shrink-0">
            {isSuccess && (
              <IconSquareRoundedCheck
                size={24}
                className="text-success-default"
              />
            )}
            {isError && (
              <IconExclamationCircle size={24} className="text-error-default" />
            )}
          </div>
          {/* Message */}
          <p className="flex-1 text-neutral-primary text-base font-normal cursor-default">
            {message}
          </p>
          {/* Close Button */}
          <Button
            variant="unstyled"
            onClick={() => closeSnackbar(id)}
            className="shrink-0 text-neutral-disabled hover:opacity-80 transition-opacity cursor-pointer"
            aria-label="Close"
            icon={<IconX size={20} />}
          />
        </div>
      </SnackbarContent>
    );
  }
);
CustomSnackbar.displayName = 'CustomSnackbar';
export default CustomSnackbar;
